module.exports = __webpack_public_path__ + "img/buttonArrow.8296ee40.svg";